<template>
  <div class="audio" v-if="curaudio.length > 0" v-click-outside="hideMenu">
    <i class="bx bx-volume-full" @click="handleClick"></i>

    <ul class="submenu" v-if="showSubmenu && curaudio.length > 1">
      <li v-for="aud in curaudio" :key="aud.id" @click="playAudio(aud.id)">
        <i class="bx bx-woman" v-if="aud.person_gender === 'female'"></i>
        <i class="bx bx-man" v-else-if="aud.person_gender === 'male'"></i>
        <i class="icon normal" v-else>0</i> {{ aud.person_code }}
      </li>
    </ul>
    <audio v-for="aud in curaudio" :key="aud.id" :id="`audio_${props.engine}_${aud.id}`">
      <source :src="`${oldUrl}${audioPath}/${aud.url}`" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script lang="ts" setup>
import { api } from '@/libs/apiLocal'
import { ref, type Ref, onMounted } from 'vue'
import { clickOutside } from '@/libs/directives'

const props = defineProps<{
  engine: tAudioEngine
  id: number | string
}>()
const oldUrl: string = import.meta.env.VITE_OLD_URL
const audioPath: string = import.meta.env.VITE_AUDIO_PATH || ''
const curaudio: Ref<iAudioInfo[]> = ref([])
const vClickOutside = clickOutside
const showSubmenu = ref(false)

// read curent audio file
onMounted(() => {
  api
    .get(`/audio/public/${props.engine}/${props.id}`)
    .then((res) => {
      if (res.data.audio) {
        curaudio.value = res.data.audio
      } else {
        console.error('Audio not found')
      }
    })
    .catch((error) => {
      console.error('Error fetching audio:', error)
    })
})

function handleClick() {
  if (curaudio.value.length > 0) {
    if (curaudio.value.length > 1) {
      showSubmenu.value = !showSubmenu.value
    } else {
      playAudio(curaudio.value[0].id)
    }
  } else {
    console.warn('No audio available to play')
  }
}

function playAudio(id: number | string) {
  const atag = document.getElementById(`audio_${props.engine}_${id}`) as HTMLAudioElement | null
  if (atag) {
    atag.play()
  } else {
    console.error(`Audio element with ID audio_${props.engine}_${id} not found`)
  }
  showSubmenu.value = false
}

function hideMenu() {
  if (showSubmenu.value) {
    showSubmenu.value = false
  }
}
</script>
